import type { CourseLibrary, CourseLibraryEntry } from '../course/CourseLibrary';
export interface PlayNowConfiguration {
  courseId: string;
  opponentMode: 'solo' | 'ai';
  teeSet: string;
  windPreset: 'calm' | 'breezy' | 'windy';
  greenSpeed: 'slow' | 'standard' | 'fast';
  holes: 'front9' | 'back9' | 'full18';
  aiDifficulty: 'casual' | 'competitive' | 'expert';
  opponentShotView: 'watch' | 'condensed' | 'skip';
}
export class PlayNowController {
  constructor(private readonly library: CourseLibrary) {}
  availableCourses() {
    return this.library.list().filter((e) => e.validationStatus === 'valid');
  }
  defaultConfiguration(
    courseId = this.availableCourses()[0]?.id ?? 'tournament-pines',
  ): PlayNowConfiguration {
    return {
      courseId,
      opponentMode: 'ai',
      teeSet: 'Championship',
      windPreset: 'breezy',
      greenSpeed: 'standard',
      holes: 'full18',
      aiDifficulty: 'competitive',
      opponentShotView: 'condensed',
    };
  }
  launch(
    config: PlayNowConfiguration,
    onLaunch: (entry: CourseLibraryEntry, config: PlayNowConfiguration) => void,
  ) {
    const e = this.library.find(config.courseId);
    if (!e || e.validationStatus !== 'valid') throw new Error('Course is unavailable');
    onLaunch(e, config);
  }
}
